import { AxiosResponse } from 'axios';
import { axiosRequest } from '@/common/api/instance';
import { ProjectUserRole } from '@/types/api/project.types';
import {
  GetRolesParams,
  Role,
  UpdateSiteRoleParams,
  UpdateProjectRoleParams,
} from '@/types/api/roles.types';
import { Response as ApiResponse } from '@/types/api/response.types';
import { TableRowUser } from '@/types/api/users.types';

const resourceSites = '/sites';
const resourceProjects = '/projects';

export const getSitesRoles = async (
  params?: GetRolesParams,
): Promise<AxiosResponse<ApiResponse<Role[]>>> => {
  return axiosRequest().get(`${resourceSites}/roles`, { params });
};

export const getProjectsRoles = async (
  params?: GetRolesParams,
): Promise<AxiosResponse<ApiResponse<Role[]>>> => {
  return axiosRequest().get(`${resourceProjects}/roles`, { params });
};

export const updateSiteClientRole = async (
  siteUserRoleId: string,
  data: UpdateSiteRoleParams,
): Promise<AxiosResponse<ApiResponse<TableRowUser>>> => {
  return axiosRequest().patch(`${resourceSites}/users/${siteUserRoleId}`, data);
};

export const updateProjectClientRole = async (
  projectUserRoleId: string,
  data: UpdateProjectRoleParams,
): Promise<AxiosResponse<ApiResponse<ProjectUserRole>>> => {
  return axiosRequest().patch(`${resourceProjects}/users/${projectUserRoleId}`, data);
};
